import { Component, OnInit } from '@angular/core';
import { WhatsNewService } from 'src/app/services/whats-new.service';

@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
})
export class WhatsNewComponent implements OnInit {
  constructor(private _whatsNewService: WhatsNewService) {}

  ngOnInit(): void {
    this._whatsNewService.markSeen();
  }
}
